export const BRAND = Object.freeze({
  name: 'Thoughtseed',
  positioning: 'Founder-led systems studio',
  description:
    'Thoughtseed is a founder-led systems studio that turns complex requirements into coherent products by aligning user psychology, founder operating logic, interface design, engineering delivery, and structured handoff.',
  email: 'wave@thoughtseed.space',
  siteUrl: 'https://thoughtseed.space',
  icon: '/brand/thoughtseed-icon.png',
  mark: '/brand/thoughtseed-mark-white.svg',
})
